import { useQuery } from '@tanstack/react-query';
import { getEncryptionStatus } from '@/services/encryption/get-encryption-status';
import { EncryptionStatus } from '@/services/encryption/encryption-types';
import { useOrgStore } from '@/stores/org-store';

export const ENCRYPTION_STATUS_QUERY_KEY = 'encryption-status';

export const useGetEncryptionStatus = (
  fresh?: boolean,
  refreshKey?: number,
) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<EncryptionStatus, Error>({
    queryKey: [ENCRYPTION_STATUS_QUERY_KEY, orgId, fresh, refreshKey],
    queryFn: () => getEncryptionStatus(fresh),
    enabled: !!orgId,
  });
};
